'use client';

import dayjs, { type ConfigType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useSyncExternalStore, type FunctionComponent } from 'react';

dayjs.extend(utc);

// SSR runs in UTC and the browser in its own zone, so a locally-formatted
// timestamp can't match across hydration. useSyncExternalStore renders the
// UTC value on the server and during hydration (no mismatch), then swaps to
// the viewer's local value once mounted on the client.
const subscribe = (): (() => void) => () => {};

export const LocalDate: FunctionComponent<{
  value?: ConfigType;
  format?: string;
  className?: string;
}> = ({ value, format = 'MMM D, YYYY', className }) => {
  const text = useSyncExternalStore(
    subscribe,
    () => dayjs(value).format(format),
    () => dayjs.utc(value).format(format),
  );
  return <span className={className}>{text}</span>;
};
